import { WordType } from '../../types/SharedTypes';

type TileType = {
	word: WordType;
	getLabel: (key: string) => string;
};

export default function Tile(props: TileType) {
	const { word, getLabel } = props;
	const classes = ['glossary__tile'];

	return (
		<a href={word.url} className={classes.join(' ')} title={word.title}>
			<div className="glossary__tile-header">
				<div className="h5">{word.name}</div>
				{word.main_entry && (
					<div className="glossary__synonym">
						{getLabel('tile_synonym_for')} → <strong>{word.main_entry}</strong>
					</div>
				)}
			</div>
			<div className="glossary__tile-definition">{word.excerpt}</div>
			<div className="glossary__tile-link">{getLabel('overview_tile_cta')}</div>
		</a>
	);
}
